export default {
   "SINGUP" :"sample data ",
   "LOGGED_IN_USER_DATA":"LOGGED_IN_USER_DATA",
   "PRODUCTS":"PRODUCTS" ,
   "CART":"CART" ,
   "REMOVE_TO_CART":"REMOVE_TO_CART",
   "INCREASE_QTY":"INCREASE_QTY" ,
   "DECREASE_QTY" :"DECREASE_QTY",
   "ORDER_HISTORY" :"ORDER_HISTORY",
   "CLEAR_CART":"CLEAR_CART",
   "USERS_LIST":"USERS_LIST"
}